var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.discount !== 0)?_c('div',[_c('div',{staticClass:"lh-1"},[_vm._v(_vm._s(_vm.$t('common.discount_unit', [_vm.discountFormatValue])))]),_c('div',{staticClass:"lh-1 mt-1 text-color-help"},[_c('del',[_vm._v(_vm._s(_vm.origin))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }